import React from 'react';
import Box from '@mui/material/Box';

import { useSalonPublicTheme } from '../../../context/SalonPublicThemeContext';


const SalonPublicServiceCard = ({ children, sx, ...props }) => {
  const { layout, tokens: theme } = useSalonPublicTheme();
  const isList = layout.tokens.content.services === 'list';

  return (
    <Box
      {...props}
      component="article"
      role="listitem"
      data-orientation={isList ? 'horizontal' : 'vertical'}
      sx={{
        display: 'flex',
        flexDirection: isList ? { xs: 'column', sm: 'row' } : 'column',
        alignItems: isList ? { sm: 'center' } : 'stretch',
        gap: 2,
        minWidth: 0,
        p: 2.5,
        border: '1px solid',
        borderColor: theme.salon.border,
        borderRadius: 3,
        backgroundColor: theme.salon.surface,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default SalonPublicServiceCard;
